import { useEffect, useState } from "react";

export const Shops = () => {
  const [shopData, setShopData] = useState(
    JSON.parse(localStorage.getItem("shopData"))
  );
  useEffect(() => {
    localStorage.setItem("shopData", JSON.stringify(shopData));
  }, [shopData]);
  const [sort,setSort] = useState(1);

  const adjustFavoriteSort = (arrayInd, direction) => {
    const tempd = { ...shopData };
    let temp;
    switch (direction) {
      case "up":
        temp = tempd.favorites[arrayInd - 1];
        tempd.favorites[arrayInd - 1] = tempd.favorites[arrayInd];
        tempd.favorites[arrayInd] = temp;
        break;
      case "down":
        temp = tempd.favorites[arrayInd + 1];
        tempd.favorites[arrayInd + 1] = tempd.favorites[arrayInd];
        tempd.favorites[arrayInd] = temp;
        break;
    }
    setShopData(tempd);
  };

  const addToFavorites = (shop) => {
    const tempd = { ...shopData };
    tempd.favorites.push(shop);
    setShopData(tempd);
  };

  const removeFromFavorites = (shop) => {
    const tempd = { ...shopData };
    tempd.favorites.splice(tempd.favorites.indexOf(shop), 1);
    setShopData(tempd);
  };

  return (
    <>
      <div className="standinBg" />
      <div style={{display:"grid",gridTemplateColumns:"20% auto", paddingTop:"10px"}}>
            <div style={{marginLeft:"auto",marginRight:"auto",marginBottom:"auto", padding:"5px", width:"15vw",borderRadius:"10px", backgroundColor:"rgb(33, 37, 41)",textShadow:"2px 1px 1px #a760e9"}}>
                <h4 style={{color:"white"}}>Order of Favorites</h4>
                <table className="table table-hover table-dark" style={{borderTop:"1px solid white"}}>
                    <tbody>
                        {shopData.favorites.length > 0 ? (
                            shopData.favorites.map((item, ind) => (
                            <tr key={ind}>
                                <div style={{display:"flex",justifyContent:"space-between"}}>
                                    <div style={{display:"flex"}}>
                                        <button className="btn" onClick={() => removeFromFavorites(item)}>
                                            <i className="fa fa-times" style={{color:"red"}} aria-hidden="true" />
                                        </button>
                                        <div style={{fontSize:"20px"}}>{item}</div>
                                    </div>
                                    {shopData.favorites.length > 1 && (
                                    <span>
                                        {ind != 0 && (
                                        <button className="btn" onClick={() => adjustFavoriteSort(ind, "up")}>
                                            <i className="fa fa-arrow-up" style={{color:"white",textShadow:"2px 1px 1px #0d6efd"}} aria-hidden="true" />
                                        </button>
                                        )}
                                        {ind != shopData.favorites.length - 1 && (
                                        <button className="btn" onClick={() => adjustFavoriteSort(ind, "down")}>
                                            <i className="fa fa-arrow-down" style={{color:"white",textShadow:"2px 1px 1px #0d6efd"}} aria-hidden="true" />
                                        </button>
                                        )}
                                    </span>
                                    )}
                                </div>
                            </tr>
                            ))
                        ) : (
                            <tr>No Shops Favorited. Add Shops From Below.</tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div style={{textAlign:"center"}}>
                <div className="btn-group" role="group" data-toggle="buttons" aria-label="Basic radio toggle button group" style={{padding:"10px", width:"20vw"}}>
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" onClick={()=>setSort(0)} checked={sort == 0} readOnly/>
                    <label className="btn btn-primary" htmlFor="btnradio1">
                        A-Z
                    </label>
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio2" onClick={()=>setSort(1)} autoComplete="off" checked={sort == 1} readOnly />
                    <label className="btn btn-primary" htmlFor="btnradio2">
                        Deals
                    </label>
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio3" onClick={()=>setSort(2)} autoComplete="off" checked={sort == 2} readOnly />
                    <label className="btn btn-primary" htmlFor="btnradio3">
                        Games
                    </label>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "auto auto auto auto", justifyContent: "center",gap:"25px"}}>
                    {shopData.shops.sort((a,b) =>{
                        if(sort == 1) {
                            if(a.deals > b.deals) {
                                return -1;
                            } else if(a.deals < b.deals) {
                                return 1;
                            } else {
                                return 0;
                            }
                        } else if(sort == 2) {
                            if(a.games > b.games) {
                                return -1;
                            } else if(a.games < b.games) {
                                return 1;
                            } else {
                                return 0;
                            }
                        } else {
                            if(a.title < b.title) {
                                return -1;
                            } else if(a.title > b.title) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }
                    }).map((item, ind) => (
                    <div key={ind} style={{backgroundImage: "linear-gradient(160deg,rgba(0,0,0) 1%,rgb(71, 0, 137), rgba(0,0,0) 99%)", width: "17.5vw", height: "12.5vh", borderRadius: "5px", color: "white", textShadow:"2px 1px 1px rgba(100, 180, 250)"}}>
                        <div style={{textAlign:"center", height:"100%"}}>
                            <div style={{height:"30%", alignContent:"center"}}><h3><i>{item.title}</i></h3></div>
                            <div style={{display:"flex",justifyContent:"space-around",height:"40%",fontSize:window.innerHeight > 1200 && "20px"}}>
                                <div>Amount of Deals<div style={{fontSize:window.innerHeight > 1200 && "30px"}}>{item.deals}</div></div>
                                <div>Amount of Games<div style={{fontSize:window.innerHeight > 1200 && "30px"}}>{item.games}</div></div>
                            </div>
                            <div style={{height:"30%",alignContent:"center"}}>
                                {!shopData.favorites.includes(item.title) ? (
                                <button className="btn btn-primary btn-sm" onClick={() => addToFavorites(item.title)}>
                                    Add To Favorites
                                </button>
                                ) : (
                                <button className="btn btn-danger btn-sm" onClick={() => removeFromFavorites(item.title)}>
                                    Remove From Favorites
                                </button>
                                )}
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    </>
  );
};

export default Shops;
